export type SportKey = "football" | "basketball" | "tennis" | "american_football" | "hockey";

export const SPORT_OPTIONS = [
    { value: "football", label: "Football" },
    { value: "basketball", label: "Basketball" },
    { value: "tennis", label: "Tennis" },
    { value: "american_football", label: "American Football" },
    { value: "hockey", label: "Hockey" },
] as const satisfies ReadonlyArray<{ value: SportKey; label: string }>;

export const SOURCE_TO_SPORT: Record<string, SportKey> = {
    fb: "football",
    bb: "basketball",
    tn: "tennis",
    af: "american_football",
    hk: "hockey",
};

export const SPORT_KEY_TO_FU: Record<
    SportKey,
    "FOOTBALL" | "BASKETBALL" | "TENNIS" | "AMERICAN_FOOTBALL" | "HOCKEY"
> = {
    football: "FOOTBALL",
    basketball: "BASKETBALL",
    tennis: "TENNIS",
    american_football: "AMERICAN_FOOTBALL",
    hockey: "HOCKEY",
};

/** Extract the source prefix (e.g. "fb" from "fb:t:8102") and map to a sport key. */
export function deriveSportFromEntityId(entityId: string): SportKey | undefined {
    if (!entityId) return undefined;
    const colonIdx = entityId.indexOf(":");
    if (colonIdx <= 0) return undefined;
    const source = entityId.slice(0, colonIdx);
    return SOURCE_TO_SPORT[source];
}

/**
 * Given a list of related-entity IDs, pick the sport if all mappable entries
 * agree; otherwise return `fallback` (default `"football"`).
 * Unknown prefixes are ignored — they neither win nor block.
 */
export function deriveDefaultSport(
    entityIds: readonly string[] | undefined,
    fallback: SportKey = "football"
): SportKey {
    if (!entityIds || entityIds.length === 0) return fallback;
    const sports = new Set<SportKey>();
    for (const id of entityIds) {
        const sport = deriveSportFromEntityId(id);
        if (sport) sports.add(sport);
    }
    if (sports.size === 1) return sports.values().next().value as SportKey;
    return fallback;
}
